import React from 'react';
import BulkEditRowComponent from './BulkEditRow';
import Pagination from '../Pagination/Pagination';

interface TableComponentProps {
  data: Array<Record<string, any>>;
  headers: string[];
  currentPage: number;
  totalPages: number;
  onClickNextPage: (page: number) => void;
  onClickPreviousPage: (page: number) => void;
  onSelectRow: (id: number) => void;
  onRowClick?: (rowData: Record<string, any>) => void;
  allowSelect?: boolean;
}

const styles = require('./styles.pcss');

const BulkEditTableComponent: React.FC<TableComponentProps> = ({
  data,
  headers,
  currentPage,
  totalPages,
  onClickNextPage,
  onClickPreviousPage,
  onSelectRow,
  onRowClick,
  allowSelect = true,
}) => {
  const displayHeaders = headers.map((header) => {
    return header
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (str) => str.toUpperCase());
  });

  const handleSelectAll = () => {
    data.forEach((row) => {
      if (!row.disabled) {
        onSelectRow(row.id);
      }
    });
  };

  return (
    <div>
      <div className={styles.tableContainer}>
        <table>
          <thead>
            <tr>
              {allowSelect && (
                <th className={styles.selectAllHeader}>
                  Select
                  {data.length > 1 ? (
                    <input
                      type="checkbox"
                      onChange={handleSelectAll}
                    />
                  ) : null}
                </th>
              )}
              {displayHeaders.map((key, index) => (
                <th key={index}>{key}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row) => (
              <BulkEditRowComponent
                allowSelect={allowSelect}
                key={row.id}
                rowData={row}
                isSelected={row.isSelected}
                onSelect={onSelectRow}
                onRowClick={onRowClick}
                visibleRowData={headers}
                isDisabled={row.disabled}
              />
            ))}
          </tbody>
        </table>
      </div>
      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          maxPage={totalPages}
          onClickNextPage={onClickNextPage}
          onClickPreviousPage={onClickPreviousPage}
        />
      )}
    </div>
  );
};

export default BulkEditTableComponent;
